import { InjectionToken, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ActivityMonitoringEffect } from './activity-monitoring/activity-monitoring.effect';
import { featureName, initialState, metaReducers, reducers } from './agent.store';
import { AppointmentEffect } from './appointment/appointment.effect';
import { ChatEffect } from './chat/chat.effect';
import { CobrowsingEffect } from './cobrowsing/cobrowsing.effect';
import { AgentMailEffect } from './mail/mail.effect';

const STORE_REDUCER = new InjectionToken('STORE_REDUCER');
const STORE_CONFIG = new InjectionToken('STORE_CONFIG');

@NgModule({
  imports: [
    // declare store effects
    EffectsModule.forFeature([AppointmentEffect, AgentMailEffect, ActivityMonitoringEffect, ChatEffect, CobrowsingEffect]),
    StoreModule.forFeature(featureName, STORE_REDUCER, STORE_CONFIG),
  ],
  providers: [
    // reducers
    {
      provide: STORE_REDUCER,
      useValue: reducers,
    },

    // metareducers
    {
      provide: STORE_CONFIG,
      useValue: {
        initialState,
        metaReducers,
      },
    },
  ],
})
export class AgentStoreModule {}
